import React, { useState, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow } from "swiper/modules";
// import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai"; // Import React Icons
import { FaStar, FaPlus, FaMinus, } from "react-icons/fa";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import axios from "axios";

// import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "./slider.css";
import { Recommend } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { addToCart, getCartCount } from "../../../utils/cartUtils";
import { LiaTimesSolid } from "react-icons/lia";
import { TfiRulerAlt } from "react-icons/tfi";

const styles = `
  @keyframes wiggle {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-3px); }
    50% { transform: translateX(3px); }
    75% { transform: translateX(-3px); }
  }
  .wiggle {
    animation: wiggle 0.2s ease-in-out 3;
  }
  .disabled-overlay::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 8%;
    right: 8%;
    height: 1px;
    background-color: #9ca3af; /* gray-400 */
    transform: translateY(-50%);
    pointer-events: none;
  }
`;


const Recommended3 = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSizeId, setSelectedSizeId] = useState(null);
  const [selectedStock, setSelectedStock] = useState(null);
  const [quantity, setQuantity] = useState(1);

  const [showPrev, showNext] = useState(true);


  const [showSizeChart, setShowSizeChart] = useState(false);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [themeColor, setThemeColor] = useState("#000");
  const swiperRef3 = useRef(null);
  const [selectedSizePrice, setSelectedSizePrice] = useState(null);
  const navigate = useNavigate();

  const [chartImage, setChartImage] = useState(null);
  const [chartImage2, setChartImage2] = useState(null);
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const [message, setMessage] = useState(null);
  const [isQuantityLeftFactual, setIsQuantityLeftFactual] = useState(false);
  const [quantityLeftFactualValue, setQuantityLeftFactualValue] = useState(1);
  const [showStock, setShowStock] = useState(false);
  const [randomStocks, setRandomStocks] = useState([]);
  const [isMarketingKeysLoading, setIsMarketingKeysLoading] = useState(true);

  const clearMessage = () => {
    setTimeout(() => {
      setMessage(null);
    }, 2000); // Clear message after 2 seconds
  };

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  useEffect(() => {
    const fetchMarketingKeys = async () => {
      setIsMarketingKeysLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_marketing_keys`,
          {
            admin_auto_id,
            app_type_id,
          }
        );

        if (response.data.status === "1" && response.data.data.length > 0) {
          const apiData = response.data.data[0];
          setIsQuantityLeftFactual(apiData.is_quantity_left_factual);
          setQuantityLeftFactualValue(apiData.quantity_left_factual_value);
        } else {
          console.error("Failed to fetch marketing keys:", response.data.msg);
        }
      } catch (error) {
        console.error("Error fetching marketing keys:", error);
      } finally {
        setIsMarketingKeysLoading(false);
      }
    };

    fetchMarketingKeys();
  }, [admin_auto_id, app_type_id]);

  // Set random stocks based on marketing keys
  useEffect(() => {
    if (isMarketingKeysLoading || !selectedProduct) {
      return;
    }

    const shouldShowStock = Math.random() < 0.9;
    setShowStock(shouldShowStock);

    if (shouldShowStock && selectedProduct.size?.length > 0) {
      const stock = parseInt(quantityLeftFactualValue, 10);
      if (isNaN(stock) || stock <= 0) {
        setRandomStocks(selectedProduct.size.map(() => 0));
      } else {
        const newRandomStocks = selectedProduct.size.map(() =>
          Math.floor(Math.random() * stock) + 1
        );
        setRandomStocks(newRandomStocks);
      }
    } else {
      const originalStocks = selectedProduct.size.map((size) =>
        parseInt(size.size_stock, 10)
      );
      setRandomStocks(originalStocks);
    }
  }, [isMarketingKeysLoading, selectedProduct, quantityLeftFactualValue]);


  useEffect(() => {
    if (selectedProduct) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedProduct]);


  const fetchSizeChart = async () => {
    // If already visible, just hide it
    if (showSizeChart) {
      setShowSizeChart(false);
      return;
    }

    // If image already fetched, just show it
    if (chartImage) {
      setShowSizeChart(true);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_size_chart_list`,
        {
          admin_auto_id,
          app_type_id,
        }
      );

      if (response.data.status === "1" && response.data.getalldata.length > 0) {
        const img = response.data.getalldata[0].chart_image;
        const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img}`;
        const img2 = response.data.getalldata[0].international_size_chart;
        const imageUrl2 = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/SizeChart/${img2}`;
        setChartImage(imageUrl);
        setChartImage2(imageUrl2);
        setShowSizeChart(true);
      } else {
        setMessage("Size chart not available.");
      }
    } catch (error) {
      console.error("Failed to load size chart:", error);
    } finally {
      clearMessage();

    }
  };

  useEffect(() => {

    const fetchProducts = async () => {
      try {
        const adminId = sessionStorage.getItem("admin_auto_id");
        const appTypeId = sessionStorage.getItem("app_type_id");
        const accessToken = sessionStorage.getItem("accessToken");
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_new_product_list`,
          {
            admin_auto_id: adminId,
            app_type_id: appTypeId,
            component_auto_id: data._id,
            component_type: "Recommended",
            limit: 6,
            page_number: 1,
            customer_auto_id: accessToken || adminId,
          }
        );

        if (response.data.status === 1) {
          const formattedProducts = response.data.get_products_lists.map(
            (product) => ({
              id: product.product_auto_id,
              name: product.product_name,
              price: `${product.final_product_price}`,
              originalPrice: product.product_price
                ? `₹${product.product_price}`
                : undefined,
              discount: product.offer_percentage
                ? `${product.offer_percentage}% OFF`
                : undefined,
              reviews: product.total_reviews || 0,
              rating: product.average_rating || 0,
              images: Array.isArray(product.product_images)
                ? product.product_images.map(
                  (img) =>
                    `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${img.product_image}`
                )
                : [],

              user_auto_id: product.user_auto_id,
              size: product.size,
              get_price_lists: product.get_price_lists,
              offer_data: product.offer_data,
              moq: product.moq,
              description: product.description
            })
          );
          setProducts(formattedProducts);
        } else {
          throw new Error("Failed to fetch products");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  if (loading || products.length === 0) {
    return null;
  }


   return (
     <section
       className={`p-1 sm:p-5 ${data.web_title_font}  rounded-lg `}
       style={{ backgroundColor: data.web_background_color }}
     >
       <style>{styles}</style>
       <h2
         className={`text-${data.title_alignment} text-3xl font-bold`}
         style={{
           color: data.web_title_color,
         }}
       >
         {data.title}
       </h2>
       <div className="relative flex items-center justify-center">
   {/* ✅ Desktop Buttons (same as before) */}
   <div className="hidden sm:flex items-center">
     {showPrev && (
       <button
         className={`custom-prev-${data._id} text-black text-3xl cursor-pointer`}
       >
         <IoIosArrowDropleft />
       </button>
     )}
   </div>
 
   {/* ✅ Mobile Buttons (over the image) */}
   <button
     className={`custom-prev-${data._id} absolute left-2 top-1/2 -translate-y-1/2 z-10 
                 text-white bg-black/40 hover:bg-black/70 p-2 rounded-full 
                 transition-all duration-300 sm:hidden`}
   >
     <IoIosArrowDropleft size={26} />
   </button>
 
   <Swiper
     ref={swiperRef3}
     modules={[Navigation, EffectCoverflow]}
     effect="coverflow"
     grabCursor
     centeredSlides={products.length >= 3}
     loop={true}
     watchOverflow={true}
     navigation={{
       prevEl: `.custom-prev-${data._id}`,
       nextEl: `.custom-next-${data._id}`,
     }}
     pagination={{ clickable: true }}
     coverflowEffect={{
       rotate: 0,
       stretch: 0,
       depth: 350,
       modifier: 1,
     }}
     className=""
     onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
     breakpoints={{
       320: {
         slidesPerView: Math.min(products.length, 1.7),
       },
       768: {
         slidesPerView: Math.min(products.length, 2),
       },
       1024: {
         slidesPerView: Math.min(products.length, 3),
       },
       1280: {
         slidesPerView: Math.min(products.length, 4),
       },
     }}
   >
     {products.map((product, index) => (
       <SwiperSlide key={product.id}>
         <Link
           to={`/product-detail/${product.id}`}
           className="no-underline text-inherit"
         >
           <div
   className={`relative bg-white rounded-xl transition-all duration-300 ease-in-out ${
     activeIndex === index
       ? "sm:scale-100 scale-x-[1.25] origin-center z-20" // ✅ Active slide: wider equally from center
       : "sm:scale-100 scale-x-90 origin-center z-10" // ✅ Side slides: slightly narrower
   }`}
 >
 
             {/* Image Wrapper */}
             <div className="relative">
               <img
                 src={
                   product.images && product.images.length > 0
                     ? product.images[0]
                     : "https://placehold.co/600x400"
                 }
                 alt={product.name}
                 className="w-full h-[450px] object-cover rounded-t-xl"
               />
               {/* Discount Tag */}
               {product.discount &&
                 parseFloat(product.discount.replace("% off", "")) > 0 && (
                   <div className="absolute top-0 left-0 px-3 py-1 text-xs font-bold text-white bg-red-600 rounded-tl-xl rounded-br-xl">
                     {product.discount}
                   </div>
                 )}
 
               {/* Rating Tag */}
               <div className="absolute bottom-2 left-2 bg-white text-black text-sm px-2 py-0.5 rounded-full flex items-center shadow-md">
                 {product.rating}
                 <FaStar className="ml-2 text-yellow-500" />
               </div>
 
               {/* Quick View Button */}
               {index === activeIndex && (
                 <button
                   className="absolute px-4 py-2 text-xs text-white transform -translate-x-1/2 rounded-md shadow-lg bottom-3 left-1/2"
                   style={{ backgroundColor: themeColor }}
                   onClick={(e) => {
                     e.preventDefault();
                     setSelectedProduct(product);
                   }}
                 >
                   Quick View
                 </button>
               )}
             </div>
 
             <div className="p-3 py-1">
               <h3 className="text-sm font-semibold truncate">
                 {product.name}
               </h3>
               <div className="flex items-start justify-start gap-1">
                 <span className="text-sm text-black">{product.price}</span>
                 {product.discount &&
                   parseFloat(product.discount.replace("% off", "")) > 0 && (
                     <span className="text-gray-500 line-through text-xs mt-0.5">
                       {product.originalPrice}
                     </span>
                   )}
               </div>
             </div>
           </div>
         </Link>
       </SwiperSlide>
     ))}
   </Swiper>
 
   {/* ✅ Desktop Right Button (same as before) */}
   <div className="hidden sm:flex items-center">
     <button
       className={`custom-next-${data._id} text-black text-3xl cursor-pointer`}
     >
       <IoIosArrowDropright />
     </button>
   </div>
 
   {/* ✅ Mobile Right Button (over image) */}
   <button
     className={`custom-next-${data._id} absolute right-2 top-1/2 -translate-y-1/2 z-10 
                 text-white bg-black/40 hover:bg-black/70 p-2 rounded-full 
                 transition-all duration-300 sm:hidden`}
   >
     <IoIosArrowDropright size={26} />
   </button>
 </div>
 
 
       {/* Right Sidebar for Product Details */}
       {selectedProduct && (
   <div className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm flex justify-end sm:justify-end items-end sm:items-start transition-all duration-300">
     <div
   className={`bg-white shadow-2xl w-full sm:w-[500px] 
     h-[80vh] sm:h-full rounded-t-3xl sm:rounded-none flex flex-col
     ${selectedProduct ? "mobile-slide-up sm:translate-x-0" : "translate-y-full sm:translate-x-full"}`}
 >
 
       {/* Header with title and close button */}
       <div className="flex items-center justify-between px-4 py-3 border-b border-gray-300">
         <p
           className="mb-0 text-lg font-bold text-black"
           onClick={() => setSelectedProduct(null)}
         >
           CHOOSE OPTION
         </p>
         <button
           className="text-xl text-gray-500"
           onClick={() => setSelectedProduct(null)}
         >
           <LiaTimesSolid />
         </button>
       </div>
 
       {/* Content area */}
       <div className="relative flex-1 py-3 pl-10 pr-3 overflow-y-auto">
         {/* Product Image Slider */}
         <Swiper
           slidesPerView={1.5}
           spaceBetween={10}
           loop={selectedProduct.images && selectedProduct.images.length > 2}
           pagination={{ clickable: true }}
           className="mt-3 mb-3"
         >
           {selectedProduct.images && selectedProduct.images.length > 0 ? (
             selectedProduct.images.map((image, index) => (
               <SwiperSlide key={index}>
                 <img
                   src={image}
                   alt={`${selectedProduct.name} ${index + 1}`}
                   className="object-cover w-full h-72"
                 />
               </SwiperSlide>
             ))
           ) : (
             <SwiperSlide>
               <img
                 src="https://placehold.co/600x400"
                 alt="No image available"
                 className="object-cover w-full rounded-lg h-60"
               />
             </SwiperSlide>
           )}
         </Swiper>
 
         {/* ✅ Keep your existing content untouched below this line */}
         <h2 className="text-lg font-bold truncate">{selectedProduct.name}</h2>
         <p className="mt-2 text-gray-600 truncate">{selectedProduct.description}</p>
               <div className="flex items-center justify-start mt-1">
                 <span className="mr-3 text-lg font-semibold">
                   {`Rs. ${selectedSizePrice ? selectedSizePrice : selectedProduct.price
                     }`}
                 </span>
                 {selectedProduct.discount &&
                   parseFloat(selectedProduct.discount.replace("% off", "")) >
                   0 && (
                     <span className="text-sm text-gray-500 line-through">
                       {selectedProduct.originalPrice}
                     </span>
                   )}
               </div>
 
               {/* Size Selection */}
               {selectedProduct.size?.length > 0 && (
                 <>
                   <div className="mt-3">
                     <div className="flex items-center justify-between ">
                       <label className="font-bold">Select</label>
                       {/* Size Chart Toggle */}
                       {(chartImage || chartImage2) && (
                         <div className="text-end">
                           <button
                             className="flex items-center justify-end gap-1 mt-2 text-black"
                             onClick={fetchSizeChart}
                           >
 
                             <TfiRulerAlt className="text-base" />
                             {showSizeChart ? (
                               <span className="underline">Size Chart</span>
                             ) : (
                               <>
                                 <span className="underline">Size Chart</span>
                               </>
                             )}
                           </button>
                         </div>
                       )}
 
                     </div>
 
                     <div className="flex gap-2 mt-2">
                       {Array.isArray(selectedProduct?.size) &&
                         selectedProduct.size.map((sizeObj, index) => {
                           const actualStock = parseInt(sizeObj.size_stock, 10);
                           const isDisabled =
                             !actualStock || isNaN(actualStock) || actualStock <= 0;
                           const isSelected = selectedSize === sizeObj.size_name;
                           const displayStock = showStock
                             ? randomStocks[index]
                             : actualStock;
                           const showStockLabel =
                             actualStock > 0 &&
                             showStock &&
                             isQuantityLeftFactual &&
                             displayStock <= 5;
 
                           return (
                             <div key={sizeObj.size_auto_id} className="relative">
                               <button
                                 className={`relative border w-20 h-12 rounded-full text-sm flex items-center justify-center flex-col transition-colors duration-200 overflow-hidden
                                              ${isDisabled ? "bg-gray-200 text-gray-400 border-gray-300 cursor-not-allowed disabled-overlay" : ""}
                                              ${!isDisabled && isSelected ? "text-white" : ""}`}
                                 style={{
                                   backgroundColor:
                                     !isDisabled && isSelected ? themeColor : undefined,
                                   borderColor:
                                     !isDisabled && isSelected ? themeColor : undefined,
                                   color: !isDisabled && isSelected ? "#ffffff" : undefined,
                                 }}
                                 onClick={() => {
                                   if (isDisabled) return;
                                   setSelectedSize(sizeObj.size_name);
                                   setSelectedSizeId(sizeObj.size_auto_id);
                                   setSelectedStock(actualStock);
                                   const sizePriceObj =
                                     selectedProduct.get_price_lists[index];
                                   if (
                                     !sizePriceObj ||
                                     !sizePriceObj.final_size_price
                                   ) {
                                     setMessage("Size price not available");
                                     clearMessage();
                                     return;
                                   }
                                   setSelectedSizePrice(sizePriceObj.final_size_price);
                                 }}
                                 onMouseEnter={(e) => {
                                   if (!isSelected && !isDisabled) {
                                     e.currentTarget.style.backgroundColor = themeColor;
                                     e.currentTarget.style.color = "#ffffff";
                                   }
                                 }}
                                 onMouseLeave={(e) => {
                                   if (!isSelected && !isDisabled) {
                                     e.currentTarget.style.backgroundColor = "#ffffff";
                                     e.currentTarget.style.color = "#000000";
                                   }
                                 }}
                                 disabled={isDisabled}
                               >
                                 <span
                                   className={`text-base leading-none ${showStockLabel ? "mb-3" : ""
                                     }`}
                                 >
                                   {sizeObj.size_name}
                                 </span>
                                 {showStockLabel && (
                                   <span
                                     className="absolute bottom-0 left-0 right-0 px-2 py-[4px] text-[11px] text-center text-white leading-tight"
                                     style={{ backgroundColor: themeColor }}
                                   >
                                     {displayStock} left
                                   </span>
                                 )}
                               </button>
                             </div>
                           );
                         })}
                     </div>
                   </div>
 
 
 
                   {showSizeChart && chartImage && (
                     <div className="p-2 mt-2 border rounded-lg">
                       <h3 className="mb-2 text-lg font-bold">Size Chart</h3>
                       <img
                         src={chartImage}
                         alt="Size Chart"
                         className="w-full h-auto rounded"
                       />
 
                       <h3 className="mb-2 text-lg font-bold">
                         {" "}
                         International Size Chart
                       </h3>
                       <img
                         src={chartImage2}
                         alt="Size Chart"
                         className="w-full h-auto rounded"
                       />
                     </div>
                   )}
                 </>
               )}
 
 
               <div className="relative mt-5">
 
                 {message && (
                   <div
                     className="p-2 mt-2 text-sm text-center bg-white "
                     style={{
                       color: message.includes("successfully") ? "green" : "red",
                     }}
                   >
                     {message}
                   </div>
                 )}
                 {/* Flex container for quantity control and add to cart button */}
                 <div className="flex flex-row items-center gap-1">
 
                   {/* Quantity Control */}
                   <div className="flex items-center">
                     <button
                       className="bg-white px-2 py-[12px]  border-l-2 border-t-2 border-b-2 border-gray-200   rounded-l-full"
                       onClick={() => setQuantity(Math.max(1, quantity - 1))}
                     >
                       <FaMinus />
                     </button>
                     <input
                       type="number"
                       min="1"
                       value={quantity}
                       onChange={(e) => {
                         const value = Math.max(1, parseInt(e.target.value));
                         setQuantity(value);
                       }}
                       className="w-11 text-center border-t-2 border-b-2 border-gray-200   py-[8px]  [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none appearance-none" />
                     <button
                       className="bg-white px-2 py-[12px]  border-r-2 border-t-2 border-b-2  border-gray-200 rounded-r-full"
                       onClick={() => setQuantity(quantity + 1)}
                     >
                       <FaPlus />
                     </button>
                   </div>
 
                   {/* Add to Cart Button */}
                   <button
                     className={`flex-1 text-white py-[12px] rounded-full border ${selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                       ? "bg-gray-400 cursor-not-allowed"
                       : "cursor-pointer"
                       }`}
                     style={{
                       backgroundColor:
                         selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                           ? "#ccc"
                           : themeColor,
                     }}
                     onMouseEnter={(e) => {
                       if (!(selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0))) {
                         const darkenedColor = darkenHexColor(themeColor, 0.15);
                         e.currentTarget.style.backgroundColor = darkenedColor;
                       }
                     }}
                     onMouseLeave={(e) => {
                       e.currentTarget.style.backgroundColor =
                         selectedProduct.size?.length > 0 && (!selectedSize || selectedStock === 0)
                           ? "#ccc"
                           : themeColor;
                     }}
                     onClick={async (e) => {
                       e.preventDefault();
                       e.stopPropagation();
                       setMessage(null);
 
                       const moq = parseInt(selectedProduct?.moq || "1", 10);
                       const qty = parseInt(quantity, 10);
 
                       if (
                         selectedProduct.size?.length !== 0 &&
                         (!selectedSize || !selectedSizePrice)
                       ) {
                         setMessage("Please select a size");
                         clearMessage();
                         return;
                       }
 
                       if (selectedProduct.size?.length !== 0 && selectedStock === 0) {
                         setMessage("Selected size is out of stock");
                         clearMessage();
                         return;
                       }
 
                       if (qty < moq) {
                         setMessage(`Minimum order quantity is ${moq}`);
                         clearMessage();
                         return;
                       }
 
                       const payload = {
                         product_auto_id: selectedProduct.id,
                         added_by_id: selectedProduct.user_auto_id,
                         cart_quantity: qty,
                         ...(selectedProduct.size?.length !== 0 && {
                           size: selectedSizeId,
                           size_price: selectedSizePrice,
                         }),
                       };
 
                       try {
                         const res = await addToCart(payload);
                         await getCartCount();
 
                         if (res?.status === "1") {
                           setMessage(res.message);
                           clearMessage();
                           setTimeout(() => {
                             navigate("/cart");
                           }, 1000);
                         } else {
                           setMessage(res.message);
                           clearMessage();
                         }
                       } catch (error) {
                         setMessage(error.message);
                         clearMessage();
                         console.log("Failed to add to cart -", error);
                       }
                     }}
                   >
                     {selectedProduct.size?.length === 0
                       ? `Add to Cart | ₹ ${selectedProduct.price}`
                       : !selectedSize
                         ? "SELECT A SIZE"
                         : selectedStock === 0
                           ? "Size Out of Stock"
                           : `Add to Cart | ₹ ${selectedSizePrice}`}
                   </button>
                 </div>
 
 
                 <div className="mt-4 text-center">
                   <Link
                     to={`/product-detail/${selectedProduct.id}`}
                     className="text-inherit"
                   >
                     <button className="text-black underline ">View Details</button>
                   </Link>
                 </div>
               </div>
             </div>
           </div>
         </div>
       )}
     </section>
   );
};

export default Recommended3;
